import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s9/b1.jpg');

class Services_9 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Detect Fast. Alert Instantly. Act Decisively."
            pagename="Fire Alarm System"
            bgimage={bnrimg}
          />

          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="blog-single-wrap-width">
                <div className="blog-post date-style-3 blog-detail text-black">
                  <div className="mt-post-media clearfix m-b30">
                    <ul className="grid-post">
                      <li>
                        <div className="portfolio-item">
                          <img
                            className="img-responsive"
                            src={require("./../../images/s9/b2.jpeg")}
                            alt="Fire Alarm System"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-post-title">
                    <h3 className="post-title font-weight-600">Fire Alarm System</h3>
                  </div>

                  <div className="mt-post-text">
                    <p><strong>"Detection is your first line of defense. Silence is never acceptable."</strong></p>

                    <p>
                      At <strong>I‑Smart Engineering Works</strong>, we specialize in high-precision fire alarm systems designed for life-critical environments. Our solutions detect flames, smoke, and heat swiftly—triggering alert protocols to ensure rapid response and evacuation.
                    </p>

                    <p>
                      Built on military-grade reliability and compliance, our systems feature addressable panels, photoelectric and ionization detectors, and seamless integration with PA, sprinklers, and monitoring—providing a layered defense strategy.
                    </p>

                    <h4 className="font-weight-600">Our Fire Alarm Services Include:</h4>
                    <ul className="list-angle-right">
                      <li>Site survey and tailored system design</li>
                      <li>Installation of control panels, detectors, and alarms</li>
                      <li>Testing, calibration, and commissioning reports</li>
                      <li>Integration with sprinklers, PA, and BMS tools</li>
                      <li>24/7 monitoring setup and remote response links</li>
                      <li>AMC for inspections, firmware upgrades, and drills</li>
                    </ul>

                    <blockquote className="bg-dark text-white author-quote">
                      <h4 className="m-b0">
                        “In combat zones, early warning saves lives. High-alert fire systems are no different.” <i className="fa fa-quote-right" />
                      </h4>
                      <div className="p-t15 text-white">
                        <strong className="text-primary">Commander A. Williams</strong>
                        <span>Naval Safety & Fire Control Unit</span>
                      </div>
                    </blockquote>

                    <p>
                      Our team adheres to NFPA, IS, and military safety standards—delivering systems tested under extreme conditions to ensure 100% reliability, always. Trust our alarms to be your early warning shield.
                    </p>

                    {/* <div className="row">
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/s9/c1.jpg")} alt="Fire Alarm Panel" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/s9/c2.jpg")} alt="Smoke Detector Install" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/s9/c3.jpg")} alt="System Commissioning" />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <p>
                      <strong>Don't wait for alarm bells to ring—prepare your defense today.</strong> Contact us for a comprehensive fire-alarm audit and tailored installation strategy.
                    </p>
                  </div>

                  <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="widget widget_tag_cloud">
                          <h4 className="tagcloud">Tags</h4>
                          <div className="tagcloud">
                            <NavLink to="#">Fire Alarm</NavLink>&nbsp;
                            <NavLink to="#">Smoke Detection</NavLink>&nbsp;
                            <NavLink to="#">Life Safety</NavLink>&nbsp;
                            <NavLink to="#">Alarm Commissioning</NavLink>&nbsp;
                            <NavLink to="#">Emergency Response</NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Services_9;
